import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output, QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {AbstractControl, FormControl, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {RxFormBuilder, RxwebValidators} from "@rxweb/reactive-form-validators";
import {AboutDataProviderService} from "../../../../features/user/project/about/about.data-provider.service";
import {ProjectViewModel} from "../../../../features/user/garage/project.view-model";
import {HistoryPostViewModel} from "../../../../features/user/project/about/history-post.view-model";
import {ModalStateEvent} from "../../modal-state-event";
import {ModalState} from "../../modal-state.enum";
import {ModalInterface} from "../../modal.interface";
import {finalize, mergeMap, forkJoin, Observable, of, Subject} from "rxjs";
import {state, style, trigger} from '@angular/animations';
import {ConfirmationService, SelectItem} from "primeng/api";
import {GarageDataProviderService} from "../../../../features/user/garage/garage.data-provider.service";
import {CurrentUserViewModel} from "../../../../core/models/current-user.view-model";
import {VehicleViewModel} from "../../../../features/user/garage/vehicle.view-model";
import {GarageStatusEnum} from "../../../../features/user/garage/garage-status.enum";
import {ModalComponent} from "../../modal.component";
import {AdvertisementTypeEnum} from "../../../../core/enums/advertisement-type.enum";
import {AdvertisementPublicationPeriodEnum} from "../../../../core/enums/advertisement-publication-period.enum";
import {ResultListApiModel} from "../../../../api/models/result-list.api.model";
import {EquipmentCategoryRestService} from "../../../../api/services/equipment-category.rest.service";
import {EquipmentCategoryApiModel} from "../../../../api/models/equipment-category.api-model";
import {MapService} from "../../../map/map.service";
import {getAddressCoordinates} from '../../../map/address-coordinates';
import {AdvertisementViewModel} from "../../../../features/marketplace/advertisement.view-model";
import {VehicleAttributes} from "../../../../core/interfaces/vehicle-attributes";
import {MarketplaceAdvertisementRestService} from "../../../../api/services/marketplace-advertisement.rest.service";
import {MarketplaceAdvertisementApiModel} from "../../../../api/models/marketplace-advertisement.api.model";
import {ProjectApiModel} from "../../../../api/models/project.api-model";
import {EquipmentApiModel} from "../../../../api/models/equipment.api-model";
import {MediaUploaderComponent} from "../../../media/media-uploader/media-uploader.component";
import {MediaUploadService} from "../../../../core/services/media-upload.service";
import {MediaObjectApiModel} from "../../../../api/models/media-object.api-model";
import {getTranslatableColorOptions} from "../../../../core/enums/color.enum";
import {Dropdown} from "primeng/dropdown";
import {plainToInstance} from "class-transformer";
import {VehicleTypeEnum} from "../../../../core/enums/vehicle-type.enum";
import {PaymentRestService} from "../../../../api/services/payment.rest.service";
import {TranslateService} from "@ngx-translate/core";
import {Capacitor} from "@capacitor/core";

@Component({
  selector: 'app-add-vehicle-advertisement',
  templateUrl: './add-vehicle-advertisement.component.html',
  styleUrls: ['./add-vehicle-advertisement.component.scss'],
  animations: [
    trigger('tabBar', [
      state('register', style({
        width: '33.3333%',
        left: '0'
      })),
      state('tier', style({
        width: '33.3333%',
        left: '33.3333%'
      })),
      state('payment', style({
        width: '33.3333%',
        left: '66.6667%'
      }))
    ])
  ],
  providers: [GarageDataProviderService, AboutDataProviderService]
})
export class AddVehicleAdvertisementComponent implements ModalInterface, OnInit, AfterViewInit {

  activeTab = 'register';

  activeCard = '';

  dropdownOptions1: SelectItem[];

  dropdownOptions2: SelectItem[];

  selectedProjectVM: ProjectViewModel = null;
  selectedColour: SelectItem<string> = null;

  selectDropdownOptions2: any;

  birthdate!: Date;

  isRelatedToExistingVehicle = true;
  isAnonymousAdvertisement = false;
  createNewProject = true;
  showHistory = false;
  showInvestments = false;
  showRankingPosition = false;
  showProfileLink = false;
  showModifiedParameters = false;

  radioButton1!: string;
  mediaProgress: number | null = null;

  data: any;
  parent: ModalComponent;
  subject: Subject<ModalStateEvent>;
  state: Observable<ModalStateEvent>;
  currentUserVM: CurrentUserViewModel;

  @Input() public projectVMs: ProjectViewModel[] = [];
  @Input() public advertisementAM: MarketplaceAdvertisementApiModel;
  @Output() onAdd: EventEmitter<HistoryPostViewModel> = new EventEmitter();
  @ViewChild('container') scrollContainer!: ElementRef;
  @ViewChild(MediaUploaderComponent) public mediaUploaderComponent: MediaUploaderComponent;
  @ViewChildren(Dropdown) private queryList: QueryList<Dropdown>;
  public form: UntypedFormGroup;
  public readonly AdvertisementTypeEnum = AdvertisementTypeEnum;
  public readonly AdvertisementPublicationPeriodEnum = AdvertisementPublicationPeriodEnum;
  public filteredProjects: ProjectViewModel[] = [];
  public advertisementType: AdvertisementTypeEnum = AdvertisementTypeEnum.VEHICLE_SALE;
  public advertisementPublicationPeriod: AdvertisementPublicationPeriodEnum = AdvertisementPublicationPeriodEnum.ONE_MONTH;
  public isSubmitted: boolean = false;
  private initialAdvertisementName: string;
  public equipmentCategoryCollection: EquipmentCategoryApiModel[] = [];
  public readonly colours: SelectItem[] = getTranslatableColorOptions();
  public highlightRequested: boolean = false;
  public paymentSummary: any = null;
  public paymentState: 'IDLE' | 'STARTED' | 'WAITING' | 'SUCCESS' | 'CANCELLED' | 'FAILED' = 'IDLE';
  public checkoutInProgress: boolean = false;
  public paymentErrorMessage: string | null = null;
  private saveAsDraft: boolean = false;

  get canSaveAsDraft(): boolean {
    if (!this.advertisementAM) {
      return true;
    }

    const isArchived = this.isOfferArchived(this.advertisementAM);

    return this.advertisementAM.listingPublicationStatus !== 'PUBLISHED' || isArchived;
  }

  get canEditPublicationPeriod(): boolean {
    if (!this.advertisementAM) {
      return true;
    }

    const isArchived = this.isOfferArchived(this.advertisementAM);

    return this.advertisementAM.listingPublicationStatus !== 'PUBLISHED' || isArchived;
  }

  get canEditAdvertisementType(): boolean {
    if (!this.advertisementAM) {
      return true;
    }

    const isArchived = this.isOfferArchived(this.advertisementAM);

    return this.advertisementAM.listingPublicationStatus !== 'PUBLISHED' || isArchived;
  }

  get submitButtonLabelKey(): string {
    if (this.paymentSummary?.requiresPayment) {
      return 'shared.modal.modal_service.add_vehicle_advertisement.go_to_payment';
    }

    return this.advertisementAM
      ? 'common.button.confirm_changes'
      : 'common.button.create_advertisement';
  }

  constructor(
    private readonly fb: RxFormBuilder,
    private readonly garageDPS: GarageDataProviderService,
    private readonly equipmentCategoryRS: EquipmentCategoryRestService,
    private readonly marketplaceAdvertisementRS: MarketplaceAdvertisementRestService,
    private readonly paymentRS: PaymentRestService,
    private readonly mapService: MapService,
    private readonly mediaUploadService: MediaUploadService,
    private readonly confirmationService: ConfirmationService,
    private readonly translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.advertisementAM = this.data['offer'];
    this.activeTab = 'register';
    this.initialAdvertisementName = this.translate.instant(
      this.advertisementAM?.['@id']
        ? 'shared.modal.modal_service.update_advertisement.title'
        : 'shared.modal.modal_service.add_advertisement.title'
    );
    this.parent.name = this.initialAdvertisementName;
    this.currentUserVM = this.data['currentUserVM'];
    this.highlightRequested = this.advertisementAM?.highlightRequested ?? false;
    this.advertisementAM = this.hasPersistedAdvertisement(this.advertisementAM) ? this.advertisementAM : null;
    if (this.advertisementAM) {
      const existingType = this.advertisementAM.type as AdvertisementTypeEnum | undefined;
      this.advertisementType = existingType ?? AdvertisementTypeEnum.VEHICLE_SALE;
      const existingPeriod = this.advertisementAM.period as AdvertisementPublicationPeriodEnum | undefined;
      this.advertisementPublicationPeriod = existingPeriod ?? AdvertisementPublicationPeriodEnum.ONE_MONTH;
      if (this.canEditPublicationPeriod && this.advertisementPublicationPeriod === AdvertisementPublicationPeriodEnum.SIX_MONTHS) {
        this.advertisementPublicationPeriod = AdvertisementPublicationPeriodEnum.THREE_MONTHS;
      }
      this.showHistory = !!this.advertisementAM.visibleHistory;
      this.showInvestments = !!this.advertisementAM.visibleCosts;
      this.showRankingPosition = !!this.advertisementAM.visibleRankingPosition;
      this.showProfileLink = !!this.advertisementAM.visibleProfileLink;
      this.showModifiedParameters = !!this.advertisementAM.showParametersModifications;
      this.isAnonymousAdvertisement = !!this.advertisementAM.anonymous;
      this.saveAsDraft = !!this.advertisementAM.saveAsDraft;
    }
    this.loadPaymentPricingPreview();
    if (this.advertisementAM?.slug && this.highlightRequested) {
      this.syncExistingPaymentState(this.advertisementAM.slug);
    }
    this.equipmentCategoryRS.getCollection().subscribe((resultListAM: ResultListApiModel<EquipmentCategoryApiModel>) => {
      this.equipmentCategoryCollection = resultListAM.records;
      console.log(this.equipmentCategoryCollection);
    });
    this.createForm();

    const coordinates = getAddressCoordinates(this.advertisementAM?.addresses?.[0]);
    forkJoin([
      this.garageDPS.fetchResources(this.currentUserVM),
      coordinates ? this.mapService.reverseGeocode(coordinates[1], coordinates[0]) : of(null)
    ]).subscribe(([projectVMs, reverseGeocodeRes]: [ProjectViewModel[], any]) => {
      this.projectVMs = projectVMs;
      this.filteredProjects = projectVMs;

      if (this.advertisementAM) {
        if (reverseGeocodeRes) this.form.get('address').patchValue([{label: reverseGeocodeRes.display_name, value: reverseGeocodeRes}]);
        this.selectedProjectVM = this.projectVMs.find(e => e['@id'] === this.getProjectIri(this.advertisementAM.project));
        if (this.selectedProjectVM) {
          this.advertisementAM.project.equipment = this.selectedProjectVM.equipment;
          this.processSelectedProject();
        }

        this.form.patchValue({
          // title: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return this.advertisementType === AdvertisementTypeEnum.SERVICE } })],
          description: this.advertisementAM.description,
          price: this.advertisementAM.priceValue === 'NET' ? this.advertisementAM.priceNet : this.advertisementAM.priceGross,
          currency: {value: this.advertisementAM.currency, label: this.advertisementAM.currency},
          priceValue: this.advertisementAM.priceValue,
          // media: [null, []],
          invoiceVat: this.advertisementAM.invoiceVat,
          invoiceVatMargin: this.advertisementAM.invoiceVatMargin,
          toNegotiation: this.advertisementAM.toNegotiation,
          leasingAssignment: this.advertisementAM.leasingAssignment,
          leasingInitialFee: this.advertisementAM.leasingInitialFee,
          leasingMonthlyInstallment: this.advertisementAM.leasingMonthlyInstallment,
          leasingRemainingInstallments: this.advertisementAM.leasingRemainingInstallments,
          leasingBuyoutValue: this.advertisementAM.leasingBuyoutValue,
          vin: this.advertisementAM.project.attributes.vin,
          mileage: this.advertisementAM.project.attributes.mileage,
          registrationPlate: this.advertisementAM.project.attributes.registrationPlate,
          firstRegistrationInCountry: new Date(this.advertisementAM.project.attributes.firstRegistrationInCountry),
          currentColour: this.colours.find(e => e.value === this.advertisementAM.project.attributes.currentColour),
          originalColour: this.colours.find(e => e.value === this.advertisementAM.project.attributes.originalColour),
          originalPaintDiffersCurrent: this.advertisementAM.project.attributes.originalPaintDiffersCurrent,
          hasPaintCoverage: this.advertisementAM.project.attributes.hasPaintCoverage,
          hasPpfWrapCoverage: this.advertisementAM.project.attributes.hasPpfWrapCoverage,
          hasOtherWrapCoverage: this.advertisementAM.project.attributes.hasOtherWrapCoverage,
          hasOtherPaintCoverage: this.advertisementAM.project.attributes.hasOtherPaintCoverage,
          paintCoverageDescription: this.advertisementAM.project.attributes.paintCoverageDescription,
          imported: this.advertisementAM.project.attributes.imported,
          accidentFree: this.advertisementAM.project.attributes.accidentFree,
          damaged: this.advertisementAM.project.attributes.damaged,
          rightSideSteeringWheel: this.advertisementAM.project.attributes.rightSteeringWheel,
          registeredInCountry: this.advertisementAM.project.attributes.registeredInCountry,
          asoService: this.advertisementAM.project.attributes.asoService,
          registeredAsAntique: this.advertisementAM.project.attributes.registeredAsAntique,
          mechanicalTuning: this.advertisementAM.project.attributes.mechanicalTuning,
          visualTuning: this.advertisementAM.project.attributes.visualTuning,
          truckApproval: this.advertisementAM.project.attributes.truckApproval,
          equipment: this.advertisementAM.project.equipment,
        });
      }
    });

  }

  ngAfterViewInit(): void {
    this.queryList.forEach((e: Dropdown) => {
      e.el.nativeElement.removeAttribute('pautofocus');
      e.el.nativeElement.setAttribute('inputmode', 'none');
      e.focusInputViewChild?.nativeElement.removeAttribute('pautofocus');
      e.focusInputViewChild?.nativeElement.setAttribute('inputmode', 'none');
    });


  }

  private createForm() {
    const validators: Validators[] = [RxwebValidators.required(), RxwebValidators.minLength({value: 3}), RxwebValidators.maxLength({value: 255})];
    const searchValidators = [
      RxwebValidators.required(),
      RxwebValidators.minLength({value: 2}),
    ];

    this.form = this.fb.group(
      {
        title: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return this.advertisementType === AdvertisementTypeEnum.SERVICE } })],
        description: ['', [RxwebValidators.minLength({value: 10}), RxwebValidators.maxLength({value: 65000})]],
        price: [null, validators],
        currency: [null, RxwebValidators.required()],
        priceValue: [null, RxwebValidators.required()],
        address: [null, searchValidators],
        // media: [null, []],
        // location: [null, []],
        invoiceVat: [null, RxwebValidators.required()],
        invoiceVatMargin: [null, RxwebValidators.required()],
        toNegotiation: [null, RxwebValidators.required()],
        leasingAssignment: [null],
        leasingInitialFee: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { console.log(x.leasingAssignment); return x.leasingAssignment == true } })],
        leasingMonthlyInstallment: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.leasingAssignment == true } })],
        leasingRemainingInstallments: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.leasingAssignment == true } })],
        leasingBuyoutValue: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.leasingAssignment == true } })],
        vin: [null, RxwebValidators.required()],
        mileage: [null, RxwebValidators.required()],
        registrationPlate: [null, RxwebValidators.required()],
        firstRegistrationInCountry: [null, RxwebValidators.required()],
        currentColour: [null, RxwebValidators.required()],
        originalColour: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.originalPaintDiffersCurrent == true } })],
        originalPaintDiffersCurrent: [false],
        hasPaintCoverage: [false],
        hasPpfWrapCoverage: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.hasPaintCoverage == true } })],
        hasOtherWrapCoverage: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.hasPaintCoverage == true } })],
        hasOtherPaintCoverage: [null, RxwebValidators.required({ conditionalExpression: (x, y) => { return x.hasPaintCoverage == true } })],
        paintCoverageDescription: [null],
        imported: [null],
        accidentFree: [null],
        damaged: [null],
        rightSideSteeringWheel: [null],
        registeredInCountry: [null],
        asoService: [null],
        registeredAsAntique: [null],
        mechanicalTuning: [null],
        visualTuning: [null],
        truckApproval: [null],
        equipment: new UntypedFormControl({value: [], disabled: false}, []),
      }
    );

    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.subject.next(new ModalStateEvent(ModalState.VALID));
      } else {
        this.subject.next(new ModalStateEvent(ModalState.INVALID));
      }
    })
  }

  public submit(): void {
    this.saveAsDraft = false;
    this.submitInternal();
  }

  public submitDraft(): void {
    this.saveAsDraft = true;
    this.submitInternal();
  }

  private submitInternal(): void {
    if (this.checkoutInProgress || this.mediaProgress !== null || this.mediaUploaderComponent?.busy) { return; }
    this.paymentErrorMessage = null;
    this.isSubmitted = true;
    if (!this.form.valid || !this.mediaUploaderComponent) { return; }
    const updating = this.hasPersistedAdvertisement(this.advertisementAM);
    if (updating) { this.updateAdvertisementFromForm(); }
    else { this.advertisementAM = MarketplaceAdvertisementApiModel.fromMarketplaceAdvertisementVM(this.createAdvertisementVM()); }
    this.mediaProgress = 0;
    this.mediaUploaderComponent.prepareMedia(progress => this.mediaProgress = progress).pipe(
      mergeMap(selection => {
        this.advertisementAM.media = selection.media.map(media => media['@id']);
        return updating ? this.marketplaceAdvertisementRS.put(this.advertisementAM)
          : this.marketplaceAdvertisementRS.create(this.advertisementAM);
      }),
      finalize(() => this.mediaProgress = null),
    ).subscribe({
      next: saved => {
        const offer = saved || this.advertisementAM;
        this.advertisementAM = offer;
        this.attachSelectedProjectData(offer);
        if (this.saveAsDraft) { this.subject.next(new ModalStateEvent(ModalState.SUCCESS, offer)); }
        else { this.handleCheckoutFlow(offer); }
      },
      error: error => {
        this.logApiError(updating ? 'updateAdvertisement' : 'createAdvertisement', error);
        this.isSubmitted = false;
        this.paymentErrorMessage = this.translate.instant('shared.image_cropper.save_error');
      },
    });
  }

  clickNext(step: string) {
    if (this.mediaUploaderComponent?.busy || this.mediaProgress !== null) { return; }
    this.activeTab = step;

    if (this.activeTab === 'tier') {
      if (this.advertisementAM) {
        this.mediaUploaderComponent.selectMedia(this.mediaUploaderComponent.fileUploader);
      }
    }
  }

  nextStep(step: string): string {
    switch (step) {
      case 'register':
        return 'tier';
      case 'tier':
        if (this.form.invalid) {
          this.form.markAllAsTouched();
          this.form.updateValueAndValidity();
          return 'tier';
        }
        this.createAdvertisementVM();
        return 'payment';
      case 'payment':
        return 'register';
      default: return 'register';
    }
  }

  private createAdvertisementVM(): AdvertisementViewModel {
    const formValues = this.form.value;

    const vehicleAttributes: VehicleAttributes = {
      vin: formValues.vin,
      registrationPlate: formValues.registrationPlate,
      firstRegistrationInCountry: formValues.firstRegistrationInCountry,
      originalColour: formValues.originalColour?.value,
      currentColour: formValues.currentColour?.value,
      originalPaintDiffersCurrent: formValues.originalPaintDiffersCurrent,
      hasPaintCoverage: formValues.hasPaintCoverage,
      hasPpfWrapCoverage: formValues.hasPpfWrapCoverage,
      hasOtherWrapCoverage: formValues.hasOtherWrapCoverage,
      hasOtherPaintCoverage: formValues.hasOtherPaintCoverage,
      paintCoverageDescription: formValues.paintCoverageDescription,
      mileage: formValues.mileage,
      imported: formValues.imported,
      accidentFree: formValues.accidentFree,
      damaged: formValues.damaged,
      rightSteeringWheel: formValues.rightSideSteeringWheel,
      registeredInCountry: formValues.registeredInCountry,
      asoService: formValues.asoService,
      registeredAsAntique: formValues.registeredAsAntique,
      mechanicalTuning: formValues.mechanicalTuning,
      visualTuning: formValues.visualTuning,
      truckApproval: formValues.truckApproval,
    };

    const projectAM: ProjectApiModel = this.selectedProjectVM.toApiModel() || new ProjectApiModel();
    projectAM.attributes = vehicleAttributes;
    projectAM.equipment = this.filterSelectedEquipment().map(e => e['@id']) as string[];

    return {
      title: formValues.title,
      description: formValues.description,
      address: formValues.address[0].value,
      price: formValues.price,
      currency: formValues.currency.value,
      priceValue: formValues.priceValue,
      invoiceVat: formValues.invoiceVat,
      invoiceVatMargin: formValues.invoiceVatMargin,
      toNegotiation: formValues.toNegotiation,
      leasingAssignment: formValues.leasingAssignment,
      leasingInitialFee: formValues.leasingInitialFee,
      leasingMonthlyInstallment: formValues.leasingMonthlyInstallment,
      leasingRemainingInstallments: formValues.leasingRemainingInstallments,
      leasingBuyoutValue: formValues.leasingBuyoutValue,
      visibleHistory: this.showHistory,
      visibleCosts: this.showInvestments,
      visibleRankingPosition: this.showRankingPosition,
      visibleProfileLink: this.showProfileLink,
      showParametersModifications: this.showModifiedParameters,
      anonymous: this.isAnonymousAdvertisement,
      highlightRequested: this.highlightRequested,
      saveAsDraft: this.saveAsDraft,
      relatedToExistingVehicle: !this.isRelatedToExistingVehicle,
      project: projectAM,
      type: this.advertisementType,
      period: this.advertisementPublicationPeriod,
    };
  }


  updateAdvertisementFromForm(): void {
    if (!this.form || !this.advertisementAM) return;

    const formValues = this.form.getRawValue();
    this.advertisementAM = plainToInstance(
      MarketplaceAdvertisementApiModel,
      {
        ...this.advertisementAM,
        address: formValues.address[0].value,
        description: formValues.description,
        price: formValues.price,
        currency: formValues.currency.value,
        priceValue: formValues.priceValue,
        invoiceVat: formValues.invoiceVat,
        invoiceVatMargin: formValues.invoiceVatMargin,
        toNegotiation: formValues.toNegotiation,
        leasingAssignment: formValues.leasingAssignment,
        leasingInitialFee: formValues.leasingInitialFee,
        leasingMonthlyInstallment: formValues.leasingMonthlyInstallment,
        leasingRemainingInstallments: formValues.leasingRemainingInstallments,
        leasingBuyoutValue: formValues.leasingBuyoutValue,
        project: {
          ...this.advertisementAM.project,
          equipment: formValues.equipment,
          attributes: {
            ...this.advertisementAM.project.attributes,
            vin: formValues.vin,
            mileage: formValues.mileage,
            registrationPlate: formValues.registrationPlate,
            firstRegistrationInCountry: formValues.firstRegistrationInCountry
              ? new Date(formValues.firstRegistrationInCountry)
              : null,
            currentColour: formValues.currentColour?.value,
            originalColour: formValues.originalColour?.value,
            originalPaintDiffersCurrent: formValues.originalPaintDiffersCurrent,
            hasPaintCoverage: formValues.hasPaintCoverage,
            hasPpfWrapCoverage: formValues.hasPpfWrapCoverage,
            hasOtherWrapCoverage: formValues.hasOtherWrapCoverage,
            hasOtherPaintCoverage: formValues.hasOtherPaintCoverage,
            paintCoverageDescription: formValues.paintCoverageDescription,
            imported: formValues.imported,
            accidentFree: formValues.accidentFree,
            damaged: formValues.damaged,
            rightSteeringWheel: formValues.rightSideSteeringWheel,
            registeredInCountry: formValues.registeredInCountry,
            asoService: formValues.asoService,
            registeredAsAntique: formValues.registeredAsAntique,
            mechanicalTuning: formValues.mechanicalTuning,
            visualTuning: formValues.visualTuning,
            truckApproval: formValues.truckApproval,
          },
        },
        visibleHistory: this.showHistory,
        visibleCosts: this.showInvestments,
        visibleRankingPosition: this.showRankingPosition,
        visibleProfileLink: this.showProfileLink,
        showParametersModifications: this.showModifiedParameters,
        anonymous: this.isAnonymousAdvertisement,
        highlightRequested: this.highlightRequested,
        saveAsDraft: this.saveAsDraft,
        period: this.canEditPublicationPeriod
          ? this.advertisementPublicationPeriod
          : (this.advertisementAM.period as AdvertisementPublicationPeriodEnum ?? this.advertisementPublicationPeriod),
      }
    );
  }

  private attachSelectedProjectData(offer: MarketplaceAdvertisementApiModel): void {
    if (!offer || !this.selectedProjectVM?.vehicle) {
      return;
    }
    if (!offer.project) {
      offer.project = this.selectedProjectVM.toApiModel();
    }
    if (typeof offer.project.vehicle === 'string' || !offer.project.vehicle) {
      offer.project.vehicle = this.selectedProjectVM.vehicle as any;
    }
  }

  selectTier(card: string) {
    this.activeCard = card;
    this.activeTab = 'payment';
  }

  searchProjects(val: string) {
    this.filteredProjects = this.projectVMs.filter(e => {
      return (e.alias && e.alias.includes(val)) || e.vehicle.fullVehicleIdentity.includes(val);
    })
  }

  getLabel(result: any) {
    // console.log(this.selectedProjectVM);
    return result.vehicle.fullVehicleIdentity + (result.alias ? ' | ' + result.alias : '')
  }

  configureVehicle(vehicleVM: VehicleViewModel | null) {
    if (!vehicleVM) {
      this.selectedProjectVM = null;
      return;
    }

    this.selectedProjectVM = new ProjectViewModel();
    this.selectedProjectVM.vehicle = vehicleVM;
    this.selectedProjectVM.user = this.currentUserVM;
    this.selectedProjectVM.status = GarageStatusEnum.ON_SALE;
  }

  processSelectedProject(): void {
    if (!this.selectedProjectVM?.vehicle?.fullVehicleIdentity) {
      this.parent.name = this.initialAdvertisementName;
      return;
    }

    this.parent.name = this.initialAdvertisementName + ' dot. ' + this.selectedProjectVM.vehicle.fullVehicleIdentity;
  }

  processSelectedColour(event): void {
    this.selectedColour = event.value;
  console.log(this.selectedColour, event);
  }

  public filterSelectedEquipment(): EquipmentApiModel[] {
    return this.equipmentCategoryCollection
      .flatMap(category => category.equipment) // Wyciąga wszystkie elementy `equipment` z każdej kategorii
      .filter(equipment => equipment.selected); // Filtruje tylko te, które są `selected`
  }

  public getEquipmentControl(): FormControl | (FormControl & AbstractControl) | (undefined & FormControl) | (undefined & FormControl & AbstractControl) {
    return this.form.get('equipment') as FormControl;
  }

  public readonly VehicleTypeEnum = VehicleTypeEnum;

  public onHighlightChange(): void {
    this.paymentState = 'IDLE';
    this.loadPaymentPricingPreview();
  }

  public onPublicationPeriodChange(): void {
    this.paymentState = 'IDLE';
    this.loadPaymentPricingPreview();
  }

  private loadPaymentPricingPreview(): void {
    const highlightPaidForCurrentSession = !!this.advertisementAM?.highlightPaid && !this.isOfferArchived(this.advertisementAM);
    this.paymentRS.getListingPricingPreview(
      this.highlightRequested,
      this.advertisementPublicationPeriod,
      highlightPaidForCurrentSession
    ).subscribe({
      next: (result) => {
        this.paymentSummary = result?.summary ?? null;
      },
      error: () => {
        this.paymentSummary = null;
      }
    });
  }

  private isOfferArchived(offer: MarketplaceAdvertisementApiModel | null | undefined): boolean {
    if (!offer?.finishedAt) {
      return false;
    }

    const parsedDate = this.parseDateValue(offer.finishedAt);
    if (!parsedDate) {
      // Defensive fallback: if finishedAt exists but cannot be parsed, treat as archived.
      return true;
    }

    return parsedDate <= new Date();
  }

  private parseDateValue(value: Date | string): Date | null {
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }

    const firstAttempt = new Date(value);
    if (!Number.isNaN(firstAttempt.getTime())) {
      return firstAttempt;
    }

    if (typeof value === 'string' && value.includes(' ') && !value.includes('T')) {
      const normalized = value.replace(' ', 'T');
      const secondAttempt = new Date(normalized);
      if (!Number.isNaN(secondAttempt.getTime())) {
        return secondAttempt;
      }
    }

    return null;
  }

  private handleCheckoutFlow(offer: MarketplaceAdvertisementApiModel): void {
    if (!offer?.slug) {
      this.checkoutInProgress = false;
      this.subject.next(new ModalStateEvent(ModalState.SUCCESS, offer));

      return;
    }

    this.checkoutInProgress = true;
    this.paymentState = 'STARTED';
    this.paymentErrorMessage = null;

    const preferAppReturn = Capacitor.isNativePlatform();
    this.paymentRS.checkoutListing(offer.slug, preferAppReturn).subscribe({
      next: (result) => {
        this.checkoutInProgress = false;

        if (!result?.requiresPayment) {
          this.paymentState = 'SUCCESS';
          this.subject.next(new ModalStateEvent(ModalState.SUCCESS, offer));

          return;
        }

        this.paymentState = 'WAITING';
        const paymentUrl = result?.payment?.url;
        if (paymentUrl) {
          window.location.href = paymentUrl;

          return;
        }
      },
      error: (error) => {
        this.checkoutInProgress = false;
        this.paymentState = 'FAILED';
        this.isSubmitted = false;
        this.paymentErrorMessage = this.extractApiErrorMessage(error);
        this.logApiError('checkoutListing', error);
      }
    });
  }

  private syncExistingPaymentState(slug: string): void {
    this.paymentRS.resolveListingPayment(slug).subscribe({
      next: (result) => {
        const status = result?.payment?.status;
        if (status === 'SUCCEEDED') {
          this.paymentState = 'SUCCESS';
        } else if (status === 'FAILED') {
          this.paymentState = 'FAILED';
        } else if (status === 'CANCELLED') {
          this.paymentState = 'CANCELLED';
        } else if (status === 'EXPIRED') {
          this.paymentState = 'FAILED';
        } else if (status) {
          this.paymentState = 'WAITING';
        }
      },
      error: () => {
      }
    });
  }

  private hasPersistedAdvertisement(advertisementAM: MarketplaceAdvertisementApiModel | null | undefined): boolean {
    return !!advertisementAM?.['@id'];
  }

  private getProjectIri(project: any): string | null {
    if (!project) {
      return null;
    }

    if (typeof project === 'string') {
      return project;
    }

    return project['@id'] ?? null;
  }

  private extractApiErrorMessage(error: any): string {
    if (error?.error?.code === 'PAYMENT_PROVIDER_MISCONFIGURED') {
      return this.translate.instant('shared.modal.modal_service.add_vehicle_advertisement.payment_provider_misconfigured');
    }

    return error?.error?.['hydra:description']
      || error?.error?.message
      || error?.message
      || 'Request failed';
  }

  private logApiError(context: string, error: any): void {
    console.error(`[AddVehicleAdvertisement:${context}]`, {
      status: error?.status,
      url: error?.url,
      message: this.extractApiErrorMessage(error),
      payload: error?.error
    });
  }

  public beforeModalCloseAttempt(): Promise<boolean> {
    return new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translate.instant('shared.modal.modal_service.add_vehicle_advertisement.exit_process_title'),
        message: this.translate.instant('shared.modal.modal_service.add_vehicle_advertisement.exit_process_message'),
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
